

const isToday = (date) => {
    return new Date(date).toDateString() == new Date().toDateString()
}


const isYesterday = (date) => {
    let today = new Date();
    let sentDate = new Date(date);
    
    today.setDate(today.getDate() - 1);
    return today.toLocaleDateString() == sentDate.toLocaleDateString()
}


const parseTimeFrame = (date, includeTime = false) => {
    if(isYesterday(date)){
        return includeTime ? "Yesterday at " + new Date(date).toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true}) : "Yesterday";
    }
    else if(isToday(date)){
        return includeTime ? "Today at " + new Date(date).toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true}) : "Today";
    }
    else{
        //Need to return "n Days Ago" if <= 7 days
        let today = new Date();
        let sentDate = new Date(date);
        let diff = today - sentDate;
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));

        if(days < 0){
            return includeTime ? `${sentDate.toLocaleString('en-US', {weekday: 'long'})} at ${sentDate.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})}` : `In ${Math.abs(days)} Days`;
        }
        else if(days < 6){
            // 2-5 days ago: weekday is unambiguous (always different from today)
            return includeTime ? `${sentDate.toLocaleString('en-US', {weekday: 'long'})} at ${sentDate.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})}` : `${days} Days Ago`;
        }
        else{
            // 6+ days ago: show full date+time to avoid weekday confusion and missing dates
            return includeTime
                ? sentDate.toLocaleString('en-US', {weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true})
                : sentDate.toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'});
        }
    }

}


export {
    isToday,
    isYesterday,
    parseTimeFrame
}